"use strict";
(function pluginMixin(global) {

  /**
  * Предоставляет дополнительные методы для для расширения функциональности классов.
  *
  * @mixin WebAccess.mixins.pluginMixin
  * @since 5.2.0.1100
  */
  global.pluginMixin = {    
    _plugins: [],

    /**
    * Преобработка параметров конструктора. Если в него был передан
    * объект со списком плагинов, то зарегистрируем их сразу же.
    * @method  WebAccess.mixins.pluginMixin#_parseArguments
    * @private
    * @since 5.2.0.1100
    */
    _parseArguments: function () {      
      var me = this;
      me._plugins = [];
      for (var arg = 0; arg < arguments.length; ++arg) {
        var param = arguments[arg];
        if ($.isPlainObject(param) && param.hasOwnProperty('plugins')) {
          var plugins = param.plugins;

          for (var i = 0; i < plugins.length; i++) {
            var plugin = plugins[i];

            if (plugin && plugin.__isPlugin === true) {
              me.registerPlugin(plugin);
            }            
          }
        };
      }      
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Регистрирует плагин. 
    *
    * Вызывается неявно, если в коструктор класса был передан список плагинов.
    * Можно вызвать вручную.
    * @param {WA.Plugin} plugin Плагин
    * @method WebAccess.mixins.pluginMixin#registerPlugin
    * @return {WebAccess.mixins.link}
    * @since 5.2.0.1100
    */
    registerPlugin: function (plugin) {
      var me = this;
      if (plugin.register && plugin.name) {
        var methods = plugin.register(me);

        for (var methodName in methods) {
          if (this.hasOwnProperty(methodName)) {
            log.warning('PLUGIN', '"'+plugin.name + '" overrides extiting method "'+ methodName + '"');
          }
          this[methodName] = methods[methodName];
        }

        this._plugins.push(plugin.name);
        log.info('PLUGIN', '"' + plugin.name + '" registered');
      } else {
        WA.raise(L('PASSED_OBJECT_IS_NOT_PLUGIN_CLASS_INSTANCE'));
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Проверяет наличие зарегистрированного плагина в классе.    
    * @param {string} pluginName Имя плагина
    * @method WebAccess.mixins.pluginMixin#isPluginRegistered
    * @return {boolean}
    * @since 5.2.0.1100
    */
    isPluginRegistered: function(pluginName) {
      return this._plugins.indexOf(pluginName) !== -1;
    }

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  };

})(window.WebAccess.mixins);